<template>
    <div class="container">
        <md-dialog :md-active.sync="modTermContr" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.contrato}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>{{ nroContrato }}</h5>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.fecha}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="fechaTerminacion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.observacion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <textarea v-model="observacion" class="form-control"></textarea>
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="terminarContrato('Terminado')">{{ labels.save }}</md-button>
                    <md-button class="md-primary" @click="terminarContrato('Anulado')">{{ labels.anular }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';

export default {
    name : 'ModTerminaContrato',
    props:['modTermContr','nroContrato'],
    data : () => ({
        fechaTerminacion : '',
        observacion : '',
    }),
    computed : {
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Terminar o anular',
                    close : 'Cerrar',
                    save : 'Terminar',
                    anular : 'Anular',
                    fecha : 'Fecha:',
                    observacion : 'Observaciones:',
                    contrato : 'Contrato:',
                }
            }else{
                return {
                    title : 'Terminate or cancel',
                    close : 'Close',
                    save : 'Terminate',
                    anular : 'Annular',
                    fecha : 'Date:',
                    observacion : 'Observations:',
                    contrato : 'Contract:',
                }
            }
        }
    },
    methods : {
        cierraModal(){
            this.fechaTerminacion = ''
            this.observacion = ''
            this.$emit('cierraModal',false)
        },
        // anularContrato(){
        //     console.log('anularContrato');
        // },
        terminarContrato(estado){

            let datosForm = {
                fechaTerm: this.fechaTerminacion,
                observaciones: this.observacion,
                nroContrato: this.nroContrato,
                estado : estado
            };

            if (Object.values(datosForm).includes('')) {
                this.$toast.error('Campo(s) pendiente(s) por diligenciar');
            } else {
                Contrato.terminarContrato(datosForm)
                .then((res) => {
                    if (res.status === 200) {
                        this.$toast.success(res.data.message);
                        this.$router.push('terminacioncontrato');
                        location.reload();
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        this.$toast.error(error.response.data.message);
                        // console.error('Error del servidor:', error.response.data);
                    } else {
                        this.$toast.error('Error de conexión con el servidor');
                        // console.error('Error de conexión:', error);
                    }
                });
            }
        }
    }
}
</script>

<style>

</style>